import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import CommonLayout from 'components/Layout/CommonLayout';
import { Webline } from 'components/Layout/Webline/Webline';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';

export const Error403 = () => {
    const { t } = useTranslation();
    const { url: homepageUrl } = useDomainConfig();

    return (
        <CommonLayout
            withoutMoveUpActionButton
            title={t('Something wrong happened... You do not have sufficient permissions')}
        >
            <Webline>
                <div className="flex flex-col items-center pb-14 pt-14">
                    <h1 data-testid="basic-heading-h1">{t('You do not have sufficient permissions')}</h1>
                    <h6>{t('We are sorry, but you do not have sufficient permissions to view this page.')}</h6>
                    <div className="leading-6 text-grayVeryDark">
                        {t('You are looking for a page that requires authorization, you may need to be logged in.')}
                    </div>
                    <div className="leading-6 text-grayVeryDark">
                        <Trans
                            i18nKey="Error403LoginOrHomepage"
                            components={{
                                link: <ExtendedNextLink href="/">{homepageUrl}</ExtendedNextLink>,
                            }}
                        />
                    </div>
                </div>
            </Webline>
        </CommonLayout>
    );
};
